import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "AddCommuneModal",
  tabindex: "-1",
  ref: "addCommuneModalRef",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Code "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Libellé "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Tarif "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_17 = {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "communeForm",
            onSubmit: _ctx.addCommune,
            "validation-schema": _ctx.communeSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_Field, {
                      name: "code",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le code"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "code",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_Field, {
                      name: "libelle",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le libellé"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "libelle",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_Field, {
                      name: "tarifs",
                      type: "number",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "0"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "tarifs",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.btntext), 1)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close shadow-none",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetValue()))
        })
      ])
    ])
  ], 512))
}